<!--
 * @Description: 
 * @Author: Lizhiliang
 * @Date: 2022-12-28 10:11:41
 * @LastEditTime: 2023-01-06 10:22:37
 * @LastEditors: lizhiliang
 * @Usage: 
-->
<template>
    <ux-form
      class="my-vertical-form"
      ref="form"
      width="340px"
      :data="formData"
      :rules="rules"
      @close="close"
      @confirm="confirm">
        <ux-form-item :label="$t('HT.user.group.name')" required prop="group_id">
            <ux-input v-model="formData.group_id" :maxlength="maxLength" :placeholder="$t('HT.number.characters.underscores', {num: maxLength})"></ux-input>
        </ux-form-item>
    </ux-form>
</template>

<script>
    export default {
      props: {
        data: {
          type: Object,
          default: () => {
            return {
              group_id: ''
            };
          }
        }
      },

      data() {
        return {
          formData: JSON.parse(JSON.stringify(this.data)),
          rules: this.$rul.addFaceUserGroup(),
          maxLength: 30
        };
      },

      methods: {

        /**
             * 取消回调
             */
        close() {
          this.$uxModal.hide();
        },

        /**
             * 确认回调
             */
        confirm() {
          this.$refs['form'].validate((valid) => {
            if (valid) {
              this.$emit('confirm', this.formData);
            }
          });
        },
      },
    };
</script>

<style lang="scss" scoped>
.ux-show-modal .ux-modal-box .ux-content > .el-form.my-vertical-form {
  padding: 16px 16px 0 16px;
}
</style>